import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  height: calc(100dvh - 60px);
  background: ${props => props.theme.backgroundSecondary};
  overflow: hidden;
`;

const Main = styled.main`
  flex: 1;
  background: ${props => props.theme.background};
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
`;

const ResponsiveContainer = ({ children }) => {
  return (
    <Container>
      <Main>
        {children}
      </Main>
    </Container>
  );
};

export default ResponsiveContainer;